export const TIME_COL_W = 48;
export const DAY_START_HOUR = 0;
export const DAY_END_HOUR = 24;
export const TOTAL_HOURS = DAY_END_HOUR - DAY_START_HOUR;
export const HOUR_HEIGHT_PX = 60;
export const TOTAL_GRID_HEIGHT_PX = TOTAL_HOURS * HOUR_HEIGHT_PX;

export const HOURS: readonly number[] = Array.from(
  { length: TOTAL_HOURS },
  (_, i) => DAY_START_HOUR + i,
);
